import styled from 'styled-components/macro';

export const Container = styled.div`
    flex: 1 0 auto;
`;
